module.exports = __webpack_public_path__ + "static/loading-a68a86bbbeef566debbc258d86ca0ff3.gif";